// extracted by mini-css-extract-plugin
export default {"MainContent":"MainContent_MainContent__O2MV8","Welcome":"MainContent_Welcome__mJCP7","Section":"MainContent_Section__-k6tL"};